"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.createConferenceError = void 0;
const Exceptions_1 = require("../lib/Exceptions");
const VoxeetApi_1 = __importDefault(require("../api/VoxeetApi"));
class ErrorReport {
    constructor(type, description) {
        this.type = 'SendErrorRequest';
        this.errorType = type;
        this.errorDescription = description;
    }
}
function createConferenceError(error) {
    //TODO: Add cases for other errors to be handled with custom error type
    if (error.code == 108 && error.status == 403) {
        throw Exceptions_1.ConferenceAtMaxCapacityError();
    }
    throw error;
}
exports.createConferenceError = createConferenceError;
/**
 * Collection of utils for conferences.
 *
 * @hidden
 */
class ConferenceUtils {
    /**
     * Reports filtered conference errors to the server.
     * @hidden
     * @param e
     * @param conferenceId
     */
    static reportError(e, conferenceId) {
        return __awaiter(this, void 0, void 0, function* () {
            if (e && e.error) {
                let data;
                if (e.error instanceof Exceptions_1.MediaStreamError) {
                    data = new ErrorReport('MediaStreamError', `${e.error.name} - ${e.error.message}`);
                }
                else if (e.error instanceof Exceptions_1.PeerError && e.error.name != 'PeerNotFoundError') {
                    data = new ErrorReport(e.error.name, e.error.message);
                }
                else if (e.error instanceof Exceptions_1.WebSocketError) {
                    data = new ErrorReport(e.error.name, e.error.message);
                }
                else if (e.error instanceof Exceptions_1.DvcError) {
                    data = new ErrorReport('DvcError', `${e.error.name}: ${e.error.message}`);
                }
                if (data) {
                    try {
                        VoxeetApi_1.default.conferences.error({
                            conferenceId: conferenceId,
                            data: JSON.stringify(data),
                        });
                    }
                    catch (e) {
                        console.error(e);
                    }
                }
            }
        });
    }
}
exports.default = ConferenceUtils;
